import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import FacebookLogin from '../common/facebook-login';
import LastDwelling from '../common/last-dwelling';
import UserLogin from '../common/forms/user-login.connected';
import i18n from 'kodyl-js/i18n/react';
import { connect } from 'react-redux';
import { getSignupPath, toUserFlowNext } from './redirection';

@connect(
  ({ auth: { user }, subscriptions: { subscriber } }) => ({ user, subscriber }),
  {}
)
@i18n
class Login extends Component {
  componentWillReceiveProps(nextProps) {
    const { user, subscriber } = nextProps;
    toUserFlowNext({ user, subscriber });
  }

  render() {
    return (
      <Grid>
        <LastDwelling page="login" />
        <h2>{this.i18n('Login')}</h2>
        <Row>
          <Col sm={8}>
            <UserLogin />
          </Col>
          <Col sm={4}>
            <h4 style={{ marginTop: 0 }}>{this.i18n('No user yet?')}</h4>
            <Link to={getSignupPath()}>
              <button type="submit" className="btn btn-primary">
                <i
                  className="fa fa-user"
                  style={{
                    marginRight: '0.5em',
                    width: '1.28571429em',
                    textAlign: 'center'
                  }}
                />
                {this.i18n('Create profile')}
              </button>
            </Link>
            <hr />
            <FacebookLogin />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Login;
